import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import { IconProps, SvgIcon } from '../SvgIcon';

interface LogoProps extends IconProps {
  isDisabled?: boolean;
  variant?: 'default' | 'small';
}

const useStyles = makeStyles(() => ({
  default: {
    height: '17.24px',
    width: '102px',
  },

  small: {
    height: '12.93px',
    width: '76.5px',
  },

  disabled: {
    '& svg path': {
      filter: 'grayscale(100%) opacity(50%)',
    },
  },
}));

export function PayGreenUpMonizze(props: LogoProps): JSX.Element {
  const classes = useStyles();
  const { isDisabled = false, variant = 'default', ...rest } = props;

  const iconStyle = clsx(
    classes.default,
    variant === 'small' && classes.small,
    isDisabled && classes.disabled,
  );

  return (
    <SvgIcon
      className={iconStyle}
      name="PayGreenUpMonizze"
      viewBox="0 0 102 17.24"
      {...rest}
    >
      <g clipPath="url(#clip0_11331_699)">
        <path d="M0 0.984619H16.0597V16.8667H0V0.984619Z" fill="#F59100" />
        <path
          d="M6.37329 8.90066C6.37329 9.7184 6.19329 10.347 5.24827 10.347C4.20763 10.347 4.12325 9.60715 4.12325 9.01192V4.32239L2.7901 4.61166V9.20662C2.76116 9.52941 2.80387 9.85457 2.91523 10.1593C3.02659 10.4641 3.20392 10.7412 3.43482 10.9711C3.66573 11.201 3.94463 11.3783 4.25204 11.4906C4.55944 11.6028 4.88792 11.6473 5.21452 11.6209C6.76705 11.6209 7.71769 10.6307 7.71769 9.39575V4.32239L6.38454 4.61166V8.90066H6.37329ZM11.0703 6.23046C10.5553 6.22809 10.0522 6.38356 9.63023 6.6755V5.93563L8.34208 6.24159V13.2564L9.6246 12.9671V11.1703C10.0486 11.463 10.5531 11.6203 11.0703 11.6209C11.4231 11.6137 11.771 11.5375 12.0939 11.3966C12.4168 11.2557 12.7082 11.0529 12.9514 10.8C13.1946 10.547 13.3848 10.249 13.5108 9.92298C13.6369 9.59699 13.6964 9.24952 13.6859 8.90066C13.6995 8.20076 13.4317 7.52415 12.9413 7.01935C12.4509 6.51455 11.778 6.22282 11.0703 6.20821V6.23046ZM10.9859 10.436C10.786 10.4332 10.5886 10.391 10.4053 10.312C10.2221 10.233 10.0565 10.1187 9.9183 9.97583C9.7801 9.83295 9.67202 9.6643 9.60035 9.47972C9.52869 9.29513 9.49486 9.09829 9.50085 8.90066C9.50085 8.51116 9.65731 8.13761 9.93581 7.8622C10.2143 7.58678 10.592 7.43205 10.9859 7.43205C11.3797 7.43205 11.7575 7.58678 12.036 7.8622C12.3144 8.13761 12.4709 8.51116 12.4709 8.90066C12.4769 9.09829 12.4431 9.29513 12.3714 9.47972C12.2997 9.6643 12.1917 9.83295 12.0535 9.97583C11.9153 10.1187 11.7497 10.233 11.5664 10.312C11.3831 10.391 11.1858 10.4332 10.9859 10.436Z"
          fill="white"
        />
        <path
          d="M20.076 16.8667L23.063 0.623045L28.3281 11.2649L33.5482 0.623045L36.6589 16.8667L33.6213 17.245L32.3331 9.1621L28.3562 17.245L24.3061 9.1621L23.063 17.245L20.0929 16.8723L20.076 16.8667ZM43.8421 4.74516C47.3522 4.74516 50.4404 7.45429 50.4404 10.9923C50.4404 14.5303 47.3522 17.245 43.8421 17.245C40.332 17.245 37.2439 14.5303 37.2439 10.9867C37.2439 7.44316 40.332 4.74516 43.8421 4.74516ZM43.8421 14.5526C44.8203 14.5706 45.7663 14.2073 46.4758 13.5411C47.1852 12.8748 47.6011 11.9593 47.6334 10.9923C47.5806 10.0332 47.1581 9.13062 46.4529 8.47018C45.7477 7.80973 44.8134 7.44165 43.8421 7.44165C42.8709 7.44165 41.9365 7.80973 41.2313 8.47018C40.5261 9.13062 40.1036 10.0332 40.0508 10.9923C40.0817 11.9598 40.4971 12.8762 41.2069 13.5427C41.9166 14.2092 42.8635 14.5721 43.8421 14.5526ZM52.0548 5.09562L54.8673 4.81747V6.45297H54.9123C55.9192 5.11231 56.9036 4.73959 58.563 4.73959C61.0212 4.73959 62.6581 6.29164 62.6581 8.78939V16.8667L59.688 17.0503V9.57932C59.688 8.33323 59.1255 7.2874 57.7699 7.2874C55.8967 7.2874 55.0304 8.70038 55.0304 10.1801V16.8556L52.0604 17.0392V5.11231L52.0548 5.09562ZM68.3676 1.94702L66.3763 3.93297L64.3625 1.9637L66.3763 0L68.3676 1.94702ZM64.8125 5.09562L67.7825 4.81747V16.8667L64.8125 17.0503V5.11231V5.09562ZM70.2632 5.09562H78.8753L73.4245 14.3022H78.8753L78.3634 16.8445H68.9694L74.4202 7.63787H69.6726L70.2801 5.09562H70.2632ZM80.5122 5.09562H89.1242L83.6735 14.3022H89.1242L88.6067 16.8445H79.2184L84.6691 7.63787H79.9215L80.5122 5.09562ZM101.325 15.6651C99.8629 16.6767 98.1256 17.2274 96.3412 17.245C92.8311 17.245 89.743 14.5359 89.743 10.9979C89.743 7.45985 92.8143 4.74516 96.3412 4.74516C97.5364 4.75745 98.7035 5.10546 99.7064 5.74861C100.709 6.39176 101.507 7.30356 102.006 8.37773L93.8661 13.3843C94.1024 13.8683 94.7549 14.5637 96.1837 14.5637C97.7025 14.5637 98.8275 14.0074 100.065 13.1785L101.325 15.6651ZM98.2594 7.93826C97.9828 7.67826 97.6557 7.47662 97.2979 7.3456C96.9401 7.21458 96.5591 7.15692 96.1781 7.17614C95.2792 7.19692 94.4202 7.54702 93.7675 8.15858C93.1148 8.77013 92.715 9.59956 92.6455 10.4861C92.6378 10.7483 92.6528 11.0107 92.6905 11.2704L98.2594 7.9327V7.93826Z"
          fill="#4F5D5B"
        />
      </g>
      <defs>
        <clipPath id="clip0_11331_699">
          <rect width="102" height="17.2394" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
